module.exports = __webpack_public_path__ + "static/media/siprc.38ca6014.png";